module.exports = __webpack_public_path__ + "img/sorry.40fca2e.jpg";